module.exports = __webpack_public_path__ + "a4f72955c9b06378f0a06dfa0a6959b5.svg";